import React, { useState, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./components/homepage/home";
import BlogPage from "./components/blogpage/blogpage";
import MoreBlog from "./components/blog/moreblogs/moreblogs";
import OtherDevicesPage from "./components/otherdevicespage/otherdevicespage";
import PrivacyPolicy from "./components/helpAndSupport/privacypolicy";
import TermsAndConditions from "./components/helpAndSupport/termsAndCondition";
import RefundPolicy from "./components/helpAndSupport/refundAndCancellationPolicy";
import { RotatingSquare } from "react-loader-spinner";
import MoreFaq from "./components/faq/morefaq/morefaq";
import PartnerTandC from "./components/helpAndSupport/partnerTandC";
import Login from "./components/otherdevicespage/login/login";
import Otp from "./components/otherdevicespage/otp/otp";
import AccountDeletion from "./components/otherdevicespage/account_deletion";
import Deleted from "./components/otherdevicespage/deleted";

const InitialLoader = () => {
  return (
    <div className="loader-container">
      <RotatingSquare
        height="100"
        width="100"
        color="#FFBE00"
        ariaLabel="rotating-square-loading"
        strokeWidth="4"
        wrapperStyle={{}}
        wrapperClass=""
        visible={true}
      />
    </div>
  );
};

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading delay
    setTimeout(() => {
      setIsLoading(false);
    }, 5); // Adjust the delay time as needed
  }, []);

  return (
    <div
      className="App"
      style={{
        visibility: isLoading ? "hidden" : "visible",
        opacity: isLoading ? 0 : 1,
      }}
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
            <Route path="/otp" element={<Otp />} />
          <Route path="/moreblogs" element={<MoreBlog />} />
          <Route path="/blogpage/:id" element={<BlogPage />} />
          <Route
            exact
            path="/otherdevicespage"
            element={<OtherDevicesPage />}
          />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/termsandconditions" element={<TermsAndConditions />} />
          <Route
            path="/refund-and-cancellation-policy"
            element={<RefundPolicy />}
          />
           <Route
            path="/partner-terms-and-conditions"
            element={<PartnerTandC />}
          />
          <Route path="/morefaq" element={<MoreFaq />} />
          <Route path="/account-deletion" element={<AccountDeletion/>}/>
          <Route path="/deleted" element={<Deleted/>}/>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
